module.exports = __webpack_public_path__ + "mou.41f473a4cb057ba6cee108ab0197f125.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/selected/mou.svg
// module id = 338
// module chunks = 0